var React = require('react');

function Settings (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.47 13.28h22.05","fill":"none","stroke":"#7888e9","strokeWidth":".83","key":0}),React.createElement("g",{"strokeWidth":"1.38","key":1},[React.createElement("g",{"fill":"none","stroke":"#86888b","key":0},React.createElement("path",{"d":"M9.47 13.28h22.05M9.47 21h22.05M9.47 28.72h22.05"})),React.createElement("g",{"fill":"#86888b","stroke":"#000","key":1},[React.createElement("circle",{"cx":"14.98","cy":"28.72","r":"3.03","key":0}),React.createElement("circle",{"cx":"26.01","cy":"21","r":"3.03","key":1}),React.createElement("circle",{"cx":"20.49","cy":"13.28","r":"3.03","key":2})])])]);
}

Settings.defaultProps = {"id":"Layer_1","viewBox":"0 0 40 42"};

module.exports = Settings;

Settings.default = Settings;
